import { render, staticRenderFns } from "./CommissionList.vue?vue&type=template&id=ae59c7e8"
import script from "./CommissionList.vue?vue&type=script&lang=js"
export * from "./CommissionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports